import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/AntdStyleRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/AuthProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
